import * as Constants from './Constants'

const initialState = { recent: null }

const Reducer = (state = initialState, action) => {
	if (action.type === Constants.ADD_RECENT) {
		return {
			recent: action.recent
		};
	}
	else {
		return state;
	}
}

export default Reducer;



// WEBPACK FOOTER //
// ./src/modules/state/recent/Reducer.js